import React from 'react';
import Header from './Header';
import Unity from './Unity';
import WhyChoise from './WhyChoise';
import KnowHealth from './KnowHealth';
import DiscoverUnity from './discoverUnity';
import Watch from './Watch';
import Client from './Client';
import Footer from './Footer';
import FooterOther from './FooterOther';

const Home = () => {
    return (
        <div>
            <Header />
            <Unity />
            <WhyChoise />
            <KnowHealth />
            <DiscoverUnity />
            <Watch />
            <Client />
            <Footer />
            <FooterOther />
        </div>
    );
};

export default Home;